<!-- Sub-Task Creation Dialog -->
<!-- Create Sub Task Dialog -->
<p-dialog header="Create Sub Task" [modal]="true" [(visible)]="displaySubTask" [style]="{ width: '60rem' }">
    <ng-container>
        <form [formGroup]="subTaskDetailForm">
            <div *ngIf="!editedSubtaskDetails" class="card p-mb-0">
                <div class="p-grid">
                    <div class="p-col-6 p-d-flex">
                        <div class="p-mr-2"><strong>Title: </strong></div>
                        <div>{{taskData?.name}}</div>
                    </div>
                    <div class="p-col-6 p-d-flex">
                        <div class="p-mr-2"><strong>Task Category: </strong></div>
                        <div>{{taskData?.taskCategory}}</div>
                    </div>
                    <div class="p-col-12 p-d-flex">
                        <div class="p-mr-2"><strong>Task Details: </strong></div>
                        <div class="task-details" [innerHTML]="getSanitizedDescription(taskData?.description)"></div>
                    </div>
                </div>
            </div>

            <!-- Loop through SubTasks -->
            <ng-container formArrayName="subTasks" *ngFor="let subTask of subTasks.controls; let i = index;">
                <div [formGroupName]="i">
                    <div *ngIf="!editedSubtaskDetails" class="header p-d-flex p-jc-between">
                        <h5 class="p-mt-1">
                            <ng-container *ngIf="selectedTaskTypeId == TaskType?.Group">SubTask: {{ i + 1 }}</ng-container>
                            <ng-container *ngIf="selectedTaskTypeId != TaskType?.Group">Sub Task ID: {{taskData?.taskId}} - {{taskData?.childTaskDto?.length + i + 1}}</ng-container>
                          </h5>
                        <!-- <h5 class="p-mt-1">Sub Task ID: {{taskData?.taskId}} - {{taskData?.childTaskDto?.length + i + 1}}</h5> -->
                        <div class="p-d-flex">
                            <p-button icon="pi pi-minus" pTooltip="Remove Sub Task" tooltipPosition="top" [disabled]="subTasks.length == 1"
                                (onClick)="removeSubTask(i)"></p-button>
                            <p-button class="p-ml-2" icon="pi pi-plus" pTooltip="Add Sub Task" tooltipPosition="top" *ngIf="i == subTasks.length - 1"
                                (onClick)="addSubTask()"></p-button>
                        </div>
                    </div>

                    <!-- Sub Task Details -->
                    <div class="card p-mb-0">
                        <div class="p-grid">
                            <div class="p-col-12 p-d-flex">
                                <label class="p-mr-2 p-mt-1">Title: </label>
                                <div class="p-mt-1">{{ subTask.get('title').value}}</div>
                                <span class="p-ml-2 btnBars" (click)="editTitle(i)">
                                    <i class="pi pi-pencil" pTooltip="Edit" tooltipPosition="top"></i>
                                </span>
                            </div>
                        </div>
                        <div class="p-grid">
                            <div *ngIf="!editedSubtaskDetails" class="p-col-12 p-d-flex p-mt-1">
                                <div class="p-mr-2">Assign To:<span style="color: red;">*</span> </div>
                                <span (click)="reassignUser(i)" *ngIf="!subTask.get('assignedTo').value"
                                    class="hyper-link">
                                    <strong class="association-name">
                                        <i class="pi pi-plus p-mr-2"></i>
                                        Select Users
                                    </strong>
                                </span>
                                <span (click)="reassignUser(i)" *ngIf="subTask.get('assignedTo').value"
                                    class="hyper-link">
                                    <strong class="association-name">
                                        <i class="pi pi-user-edit p-mr-2" pTooltip="Edit"
                                        tooltipPosition="top"></i>
                                        {{ subTask.get('assignedTo').value?.name}}
                                    </strong>
                                </span>
                            </div>
                            <div *ngIf="editedSubtaskDetails" class="p-col-12 p-d-flex p-mt-1">
                                <div class="p-mr-2">{{ editedSubtaskDetails?.reAssignedTo ? 'Re-Assigned To' : 'Assign To'}}:<span style="color: red;">*</span> </div>
                                <span (click)="reassignUser(i)" *ngIf="!editedSubtaskDetails?.reAssignedTo" class="hyper-link">
                                    <strong class="association-name">
                                        <i class="pi pi-user-edit p-mr-2" pTooltip="Edit" tooltipPosition="top"></i>
                                        {{ subTask.get('assignedTo').value?.name || 'Select Users' }}
                                    </strong>
                                </span>
                            
                                <!-- Show assigned user without edit icon if 'reAssignedTo' is available -->
                                <span *ngIf="editedSubtaskDetails?.reAssignedTo" class="hyper-link">
                                    <strong class="association-name">
                                        {{ subTask.get('assignedTo').value?.name }}
                                    </strong>
                                </span>
                            </div>
                            <div *ngIf="fieldsFormErrors?.[i]?.assignedTo" class="p-invalid p-mt-0 p-ml-2">
                                <small>{{ fieldsFormErrors?.[i]?.assignedTo }}</small>
                            </div>
                        </div>
                        <div class="p-grid">
                            <div class="p-col-12 p-md-6">
                                <label>Priority<span style="color: red;">*</span></label>
                                <p-dropdown formControlName="priority" [options]="priorityOptions"
                                    optionLabel="name" optionValue="id" placeholder="Select"
                                    appendTo="body"></p-dropdown>
                                <div *ngIf="fieldsFormErrors?.[i]?.priority" class="p-invalid p-mt-1">
                                    <small>{{ fieldsFormErrors?.[i]?.priority }}</small>
                                </div>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <label>Due Date<span style="color: red;">*</span></label>
                                <p-calendar formControlName="endDate" appendTo="body" [showIcon]="true"
                                    inputId="buttondisplay" [showTime]="true" [hourFormat]="12"></p-calendar>
                                <div *ngIf="fieldsFormErrors?.[i]?.endDate" class="p-invalid p-mt-1">
                                    <small>{{ fieldsFormErrors?.[i]?.endDate }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="p-grid">
                            <div class="p-col-12">
                                <label>Task Details<span style="color: red;">*</span></label>
                                <p-editor formControlName="description" styleClass="task-editor"
                                    [style]="{'height':'100px'}">
                                    <p-header>
                                        <span class="ql-formats">
                                            <select class="ql-size">
                                                <option value="small">small</option>
                                                <option selected></option>
                                                <option value="large">large</option>
                                                <option value="huge">huge</option>
                                            </select>
                                        </span>
                                        <span class="ql-formats">
                                            <select class="ql-size">
                                                <option value="24px">24</option>
                                                <option value="48px">48</option>
                                                <option value="100px">100</option>
                                                <option value="200px">200</option>
                                            </select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-bold" aria-label="Bold"></button>
                                            <button class="ql-italic" aria-label="Italic"></button>
                                            <button class="ql-underline" aria-label="Underline"></button>
                                            <button class="ql-strike" aria-label="Strike"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <select title="Text Color" class="ql-color"></select>
                                            <span class="ql-format-separator"></span>
                                            <select title="Background Color" class="ql-background"></select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-list" value="ordered"></button>
                                            <button class="ql-list" value="bullet"></button>
                                            <select title="Text Alignment" class="ql-align">
                                                <option selected>Gauche</option>
                                                <option value="center" label="Center"></option>
                                                <option value="right" label="Right"></option>
                                                <option value="justify" label="Justify"></option>
                                            </select>
                                        </span>
                                        <span class="ql-formats">
                                            <button aria-label="Link" class="ql-link"></button>
                                        </span>
                                    </p-header>
                                </p-editor>
                                <div *ngIf="fieldsFormErrors?.[i]?.description" class="p-invalid">
                                    <small>{{ fieldsFormErrors?.[i]?.description }}</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Divider between Sub-Tasks -->
                    <p-divider class="y_padding" type="solid" *ngIf="i !== subTasks.length - 1"></p-divider>
                </div>
            </ng-container>
        </form>
    </ng-container>
    <!-- Footer Actions -->
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelSubTask()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveSubTask()" label="Save"></button>
    </ng-template>

</p-dialog>

<!-- Edit Title Dialog -->
<p-dialog header="Edit Title" [modal]="true" [(visible)]="displayTitle" [style]="{ width: '45rem' }">
    <ng-container>
        <form [formGroup]="titleForm">
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-12">
                        <label>Title</label>
                        <input type="text" pInputText formControlName="title" />
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayTitle = false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveTitle()" label="Save"></button>
    </ng-template>
</p-dialog>

<app-assign-users [displayUsersPopup]="displayUsers" [singleSelection] ="true" [selectedUsersList]="selectedReassignUser"
    (saveAssignDataclicked)="saveReAssignUser($event)" (cancelClicked)="assignUserPopupCancelClicked()">
</app-assign-users>
